module.exports = __webpack_public_path__ + "img/brand4.f9797062.png";